import { Component, Inject, ViewChild } from '@angular/core';

import { ProductConfig } from 'app/product-designer-config';
import { ProductService } from 'core/product/product.service';
import { EventTrackingService } from 'core/tracking/event-tracking.service';
import { Utils } from 'core/utils';
import { SingleOptionChooserComponent
       } from '../single-option-chooser/single-option-chooser.component';


@Component({
    selector: 'product-chooser',
    templateUrl: './product-chooser.component.html',
    styleUrls: ['./product-chooser.component.scss'],
    standalone: false
})
export class ProductChooserComponent
    extends SingleOptionChooserComponent
{
  private productService: ProductService;
  public productSize: string;

  public trackById: (index: number, item: any) => any = Utils.trackById;

  @ViewChild('productChooser') public productChooser: any;
  constructor(
      @Inject(ProductService) productService: ProductService,
      @Inject(EventTrackingService) private eventTrackingService:
          EventTrackingService)
  {
    super();
    this.productService = productService;
    this.selectedValue = this.productService.getCurrentProduct();
    this.options = this.productService.getProducts();
  }

  public onClick(e: Event): void
  {
    this.productChooser.onContainerClick(e);
  }

  public async setCurrentProduct(productConfig: ProductConfig): Promise<void>
  {
    const oldProductId = this.productService.getCurrentProduct().id;

    if (oldProductId !== productConfig.id) {
      await this.productService.setCurrentProduct(productConfig.id);

      this.eventTrackingService.track({
        category: productConfig.id,
        action: 'product_change',
        label: oldProductId,
      });
    }
  }
}
